import React from "react";
import {
    Box,
    Text,
    Stat,
    StatLabel,
    StatNumber,
    StatHelpText,
    Progress,
    Tooltip
} from "@chakra-ui/react";

export const StatCard = ({ title, value, change, changeColor, subtitle, icon, iconColor, borderd = true, bg, isProgressBar = false, progressValue, originalValue }) => {
    return (
        <Box className={borderd ? "box-style-card" : "box-style-card-without-border"} flex="1" bg={borderd ? "" : bg} p={{ base: 3, md: 4, lg: "10px", xl: "15px" }}>
            <Stat w={"100%"} >
                <StatLabel display="flex" alignItems="center" gap={2} justifyContent={"space-between"} mb={5}>
                    <Text fontSize={"sm"} fontWeight={"500"} >{title}</Text>
                    {icon && <Box fontSize="lg" color={iconColor}>{icon}</Box>}

                </StatLabel>
                {originalValue ? <Tooltip label={originalValue} fontSize="sm" bg="gray.600" color="white" padding={2} borderRadius="md" backgroundColor={"var(--brand-primary)"}>
                    <StatNumber color={changeColor} fontWeight={"bold"}>{value}</StatNumber>
                </Tooltip> : <StatNumber color={changeColor} fontWeight={"bold"}>{value}</StatNumber>}

                {subtitle && <Text fontSize="xs" color="gray.500">{subtitle}</Text>}
                {change && (
                    <StatHelpText color={"gray.600"} fontWeight="normal" fontSize={"xs"}>
                        {change}
                    </StatHelpText>
                )}

                {isProgressBar && (
                    <Progress
                        value={progressValue}
                        size="md"
                        borderRadius="full"
                        bg="rgb(var(--brand-primary-rgb) / 0.2)"
                        mt={4}
                        sx={{
                            "& > div": {
                                backgroundColor: "var(--brand-primary)",
                            },
                        }}
                    />
                )}
            </Stat>
        </Box>
    );
};